import React from 'react';
import AttachmentRow from './AttachmentRow';
import { FormattedMessage } from 'react-intl';

const prefix = 'attachmentsTable';

export default function AttachmentsTable(props) {
  const attachments = props.attachments;
  return (
    <div className="links-attachments-section">
      {attachments?.length > 0 && (
        <>
          <div className="sub-section-header">
            <FormattedMessage id={`${prefix}.tableHeader`} defaultMessage="LINKS / ATTACHMENTS" />
            <div className="notes">
              <em>
                {' '}
                <FormattedMessage
                  id={`${prefix}.linkInfo`}
                  defaultMessage="Links to internal items are referenced, but are not accessible to you."
                />
              </em>
            </div>
          </div>
          {attachments?.map((attachment) => {
            return <AttachmentRow attachment={attachment} key={attachment.name}></AttachmentRow>;
          })}
        </>
      )}
    </div>
  );
}
